export const SHOW_DIALOG = 'SHOW_DIALOG';
export const HIDE_DIALOG = 'HIDE_DIALOG';

export const showDialog = (data, footer = true, size = 'lg') => ({type: SHOW_DIALOG, data, footer, size });
export const hideDialog = () => ({type: HIDE_DIALOG})
